import ky from '../ky';

export const getMenu = () => ky.get(`UserGroups/getMenu`);
export const getUserPermissions = () => ky.get(`UserGroups/getUserPermissions`);
export const getUserPosition = () => ky.get(`UserGroups/getUserPosition`);